
 $(document).ready(function() {
      $("variant-selection").on("change", function() {
        // Get the value of the data-variant-option-chosen-value attribute and convert to lowercase
        var va = $("span[data-variant-option-chosen-value]").attr("data-variant-option-chosen-value").toLowerCase();
        console.log("Selected Value (va) in lowercase:", va);  // Debugging: log the lowercase value

        if (va === "14k solid gold") {
          $(".disclamir").show();
          console.log("14K Solid Gold Selected");
        }
        else if (va === "10k solid gold") {
          $(".disclamir").show();
          console.log("10K Solid Gold Selected");
        }
        else {
          $(".disclamir").hide();
          console.log("Other Option Selected");
        }
      });
    });

    $(window).on('load', function () {
      // Get the value of the data-variant-option-chosen-value attribute and convert to lowercase
      var vaa = $("span[data-variant-option-chosen-value]").attr("data-variant-option-chosen-value").toLowerCase();
      let result = vaa.trim();
      console.log("Loaded Value (vaa) in lowercase:", result);  // Debugging: log the lowercase value

      if (result === "14k solid gold") {
        $(".disclamir").show();
        console.log("14K Solid Gold on Load");
      }
      else if (result === "10k solid gold") {
        $(".disclamir").show();
        console.log("10K Solid Gold on Load");
      }
      else {
        $(".disclamir").hide();
        console.log("No Gold Option on Load");
      }
    });
